<template>
  <div
    :class="classes"
    data-qa="popup-layout-heading"
  >
    <slot />

    <button
      v-if="removeLayer"
      type="button"
      :class="$style.closeButton"
      data-qa="close"
      @click="removeLayer"
    >
      <ui-icon name="close-28" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { UiIcon } from '@huntflow/ui';
import { computed, inject, useCssModule } from 'vue';
import { removeLayerSymbol } from '@/shared/legacy/ui/base-layer/constants';

defineOptions({
  name: 'PopupHeading'
});

const { border = true } = defineProps<{
  border?: boolean;
}>();

const css = useCssModule();

const removeLayer = inject(removeLayerSymbol);

const classes = computed(() => {
  return {
    [css.heading]: true,
    [css.border]: border
  };
});
</script>

<style module>
.heading {
  padding: 20px 60px 20px 24px;
  background-color: $white;
  border-radius: var(--Radius-x4, 16px) var(--Radius-x4, 16px) 0 0;
  color: #050505;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  min-width: 0;
  word-wrap: break-word;
  overflow: hidden;

  @media print {
    padding-left: 0;
    padding-right: 0;
  }
}

.border {
  border-bottom: 1px solid var(--border-neutral-S, rgba(0, 0, 0, 0.08));
}

.closeButton {
  @mixin reset-button-styles;
  position: absolute;
  border-radius: 8px;
  top: 20px;
  right: 24px;
  cursor: pointer;
  color: #a5a5a5;
  &:hover {
    background-color: $black-7;
  }
  &:active {
    background-color: #ebebeb;
  }

  @media print {
    display: none;
  }
}
</style>

<i18n lang="json">{}</i18n>
